import { Component, OnInit } from '@angular/core';
import { SettingService } from '../../../services/setting.service';
import { ErrorMessageService } from '../../../../shared/error-message.service';

@Component({
    selector: 'app-setting-system-settings',
    templateUrl: './setting-system-settings.component.html',
    styleUrls: ['./setting-system-settings.component.scss']
})
export class SettingSystemSettingsComponent implements OnInit {

    settings: any[] = [];
    editingSetting: any = null;
    editValue: string = '';
    editDescription: string = '';
    isLoading: boolean = false;
    isSaving: boolean = false;

    constructor(
        private settingService: SettingService,
        private errorMessageService: ErrorMessageService
    ) {}

    ngOnInit() {
        this.loadSettings();
    }

    loadSettings() {
        this.isLoading = true;
        this.settingService.list().subscribe(
            (response: any) => {
                this.settings = response;
                this.isLoading = false;
            },
            error => {
                this.isLoading = false;
                this.errorMessageService.showError('Failed to load settings');
            }
        );
    }

    startEdit(setting: any) {
        this.editingSetting = setting;
        this.editValue = setting.value;
        this.editDescription = setting.description || '';
    }

    cancelEdit() {
        this.editingSetting = null;
        this.editValue = '';
        this.editDescription = '';
    }

    saveSetting() {
        if (!this.editingSetting) return;

        this.isSaving = true;
        const data: any = {};

        if (this.getInputType(this.editingSetting.type) === 'checkbox') {
            data.value = this.editValue === '1' ? '1' : '0';
        } else {
            data.value = this.editValue;
        }
        data.description = this.editDescription;

        this.settingService.update(this.editingSetting.id, data).subscribe(
            (response: any) => {
                this.editingSetting.value = response.value;
                this.editingSetting.description = response.description;
                this.errorMessageService.showSuccess('Setting updated successfully');
                this.cancelEdit();
                this.isSaving = false;
            },
            error => {
                this.isSaving = false;
                const msg = error?.error?.error?.show_message || 'Failed to update setting';
                this.errorMessageService.showError(msg);
            }
        );
    }

    isBooleanType(type: string): boolean {
        return type === 'boolean' || type === 'bool';
    }

    getInputType(type: string): string {
        if (this.isBooleanType(type)) return 'checkbox';
        switch (type) {
            case 'int': return 'number';
            case 'float': return 'number';
            case 'date': return 'date';
            case 'datetime': return 'datetime-local';
            case 'string': return 'text';
            default: return 'text';
        }
    }

    getStep(type: string): string {
        return type === 'float' ? '0.01' : '1';
    }

    displayValue(setting: any): string {
        if (this.isBooleanType(setting.type)) {
            return setting.value === '1' ? 'Si' : 'No';
        }
        return setting.value;
    }

    isLongText(setting: any): boolean {
        return !this.isBooleanType(setting.type) && setting.value && setting.value.length > 50;
    }
}
